import cityService from '../../../services/location/CityService';
import stateService from '../../../services/location/StateService';

import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                    text: 'Departamento',
                    sortable: false,
                    value: "idState"
                },
                {
                    text: 'Codigo dian',
                    sortable: false,
                    value: "code"
                }
            ],
            itemsData: [],
            nroRows: 0
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchState();
    },
    methods: {
        onRowClick(item) {
            console.log(item)
            this.$emit("row-click", item);
        },
        searchState() {
            stateService.getStates().then(response => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            })
        },
        getLenght() {
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter(row => filter(row["name"], search));
        }
    }
};